import './scss/foodmovers.scss'
import vueUtil from '@/CVI/WebCore/vue-util'
import FoodMoversLoader from '@/CVI/FoodMovers/components/FoodMoversLoader.vue'

const components = {
  FoodMoversLoader
}

vueUtil.mountComponents(components)
